import { isGlobalFeatureEnabled } from 'owa-feature-flags';

import { WorkPlansDailyPeekSource } from './types';

export const isDailyPeekV2FeatureEnabled = (source?: string): boolean => {
    const isWin32Outlook = source === WorkPlansDailyPeekSource.OPX;
    const isSourceMyDayPane = source === WorkPlansDailyPeekSource.MyDayPane;

    return (
        isGlobalFeatureEnabled('cal-surface-places-daily-peek-v2') &&
        !isWin32Outlook &&
        !isSourceMyDayPane
    );
};
